const PAGE_SIZE = 20;

function initFeed(feed) {
  if (feed.dataset.topicsReady === "true") return;

  const items = Array.from(feed.querySelectorAll("[data-topic-item]"));
  const sentinel = feed.querySelector("[data-topics-sentinel]");
  if (!sentinel || items.length <= PAGE_SIZE || !("IntersectionObserver" in window)) {
    feed.dataset.topicsReady = "true";
    sentinel?.remove();
    return;
  }

  let visibleCount = PAGE_SIZE;
  items.slice(visibleCount).forEach(item => { item.hidden = true; });
  feed.classList.add("is-paginated");

  const revealNextPage = () => {
    const nextCount = Math.min(visibleCount + PAGE_SIZE, items.length);
    items.slice(visibleCount, nextCount).forEach(item => { item.hidden = false; });
    visibleCount = nextCount;

    if (visibleCount >= items.length) {
      observer.disconnect();
      sentinel.remove();
    }
  };

  const observer = new IntersectionObserver(entries => {
    if (entries[0]?.isIntersecting) revealNextPage();
  }, { rootMargin: "300px 0px" });

  observer.observe(sentinel);
  feed.dataset.topicsReady = "true";
}

export default function initTopics(root = document) {
  root.querySelectorAll("[data-topics-feed]").forEach(initFeed);
}
